import { Box, Button, Grid, Paper } from '@mui/material';
import { Form, Formik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { LockerFormErrorHandler } from '../components/LockerForm/LockerFormErrorHandler';
import { LockerFormHeader } from '../components/LockerForm/LockerFormHeader';
import { LockerBasicInfo } from '../components/LockerForm/LockerBasicInfo';
import { LockerEquipmentConfig } from '../components/LockerForm/LockerEquipmentConfig';
import { LockerNetworkSettings } from '../components/LockerForm/LockerNetworkSettings';
import { useAuth } from '../../auth/context/AuthContext';
import { useLockerForm } from '../hooks/useLockerForm';

export function LockerFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    mode,
    initialValues,
    validationSchema,
    loadingData,
    equipments,
    manufacturers,
    rooms,
    handleSubmit,
    error,
    setError
  } = useLockerForm(id);

  return (
    <Box>
      <LockerFormErrorHandler error={error} onClose={() => setError(null)} />
      
      <LockerFormHeader mode={mode as 'edit' | 'create'} />

      <Paper sx={{ p: 3, mt: 3 }}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <Grid container spacing={2}>
                <LockerBasicInfo
                  mode={mode as 'edit' | 'create'}
                  isSubmitting={isSubmitting}
                  errors={errors}
                  touched={touched}
                />

                <LockerEquipmentConfig
                  mode={mode as 'edit' | 'create'}
                  isSubmitting={isSubmitting}
                  errors={errors}
                  touched={touched}
                  loadingData={loadingData}
                  equipments={equipments}
                  manufacturers={manufacturers}
                  rooms={rooms}
                />

                <LockerNetworkSettings
                  mode={mode as 'edit' | 'create'}
                  isSubmitting={isSubmitting}
                  errors={errors}
                  touched={touched}
                />

                <Grid item xs={12} sx={{ mt: 2, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                  <Button
                    variant="outlined"
                    onClick={() => navigate('/lockers')}
                    disabled={isSubmitting}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting || loadingData}
                  >
                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Paper>
    </Box>
  );
}